import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(ScrollTrigger, SplitText);

function initWorksFadeUp() {
  document.querySelectorAll('.js-works-fade-up').forEach(el => {
    gsap.fromTo(
      el,
      { opacity: 0, y: '3rem' },
      {
        y: 0,
        opacity: 1,
        ease: 'power3.out',
        duration: 0.8,
        immediateRender: false,
        scrollTrigger: {
          trigger: el,
          start: 'top 85%',
          toggleActions: 'play none none none',
        },
      }
    );
  });
}

function initWorksChars() {
  document.querySelectorAll('.js-works-chars').forEach(el => {
    let split;
    try {
      split = new SplitText(el, {
        type: 'chars',
        charsClass: 'chars',
        wordDelimiter: '',
      });
    } catch (err) {
      console.warn('[works] SplitText failed:', err);
      return;
    }
    gsap.set(split.chars, { y: '100%', opacity: 0 });
    gsap.to(split.chars, {
      y: 0,
      opacity: 1,
      stagger: 0.04,
      ease: 'power4.out',
      duration: 1,
      immediateRender: false,
      scrollTrigger: {
        trigger: el,
        start: 'top 85%',
        toggleActions: 'play none none none',
      },
    });
  });
}

function initWorksCards() {
  const list = document.querySelector('.p-works__list');
  if (!list) return;
  const cards = list.querySelectorAll('.c-works-card');
  if (!cards.length) return;

  gsap.fromTo(
    cards,
    { opacity: 0, y: '2.4rem' },
    {
      y: 0,
      opacity: 1,
      stagger: 0.06,
      ease: 'power3.out',
      duration: 0.7,
      immediateRender: false,
      scrollTrigger: {
        trigger: list,
        start: 'top 80%',
        toggleActions: 'play none none none',
      },
    }
  );
}

function initWorksClientLogos() {
  const grid = document.querySelector('.p-works-clients__grid');
  if (!grid) return;
  const logos = grid.querySelectorAll('.c-client-logo-card');
  if (!logos.length) return;

  gsap.fromTo(
    logos,
    { opacity: 0 },
    {
      opacity: 1,
      stagger: 0.04,
      ease: 'power3.out',
      duration: 0.6,
      immediateRender: false,
      scrollTrigger: {
        trigger: grid,
        start: 'top 85%',
        toggleActions: 'play none none none',
      },
    }
  );
}

window.addEventListener('load', () => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    gsap.set(
      '.js-works-fade-up, .js-works-chars, .p-works__list .c-works-card, .p-works-clients__grid .c-client-logo-card',
      { opacity: 1, y: 0 }
    );
    return;
  }

  requestAnimationFrame(() => {
    initWorksFadeUp();
    initWorksChars();
    initWorksCards();
    initWorksClientLogos();
    ScrollTrigger.refresh();
  });
});
